import React, { useEffect } from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const InterSchoolCorner = () => {
  useEffect(() => {
    document.title = "Inter School Corner -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Inter School Corner </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Inter School Corner Competition 2026-2027</h1>
            </div>
          </div>
          <div className="row">
            <div className="table-responsive maintable">
              <table className="table">
                <thead>
                  <tr>
                    <th>Sl No </th>
                    <th>Competition </th>{" "}
                    <th>School / Venue </th>
                    <th>Date </th>{" "}
                    <th>Last Date of Registration </th>
                    <th colspan="2">Event </th>{" "}
                    <th>Classes </th>
                    <th>No. of Participants </th>{" "}
                    <th>Teacher Incharge </th>
                    <th>Remarks </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {" "}
                    <td> 1 </td>{" "}
                    <td> Goenka Grandeur 2025 </td>{" "}
                    <td> GD Goenka School, Vasant Kunj </td>{" "}
                    <td> 29 Apr-02 May 25 </td>{" "}
                    <td> 18 April 2025 </td>
                    <td colspan="2"> Declamation </td>
                    <td> XI-XII  </td>
                    <td> 2 </td>
                    <td> TSC </td>
                    <td></td>
                  </tr>

                  <tr>
                    {" "}
                    <td rowspan="15"> 2 </td>{" "}
                    <td rowspan="15"> Abhivyakti 2026</td>{" "}
                    <td rowspan="15">Gyan Mandir Public School, Naraina </td>{" "}
                    <td rowspan="15"> 30-Apr-26 (Online event)<br />
                      06-May-26 (Offline event)</td>{" "}
                    <td rowspan="15"> 16/04/2026 </td>
                    <td>a</td>
                    <td>Chemart</td>
                    <td>IX-X</td>
                    <td>2 </td>
                    <td>MNG </td>
                    <td></td>
                  </tr>

                  <tr>
                    <td>b.</td>
                    <td>Frame frenzy</td>
                    <td>VI-VIII</td>
                    <td>2</td>
                    <td>TSC</td>
                    <td></td>
                  </tr>

                  <tr>
                    <td>c.</td>
                    <td>Next gen</td>
                    <td>VI-VIII</td>
                    <td>2</td>
                    <td>ASN</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>d.</td>
                    <td>Innospark</td>
                    <td>VI-VIII</td>
                    <td>2-3</td>
                    <td>RSA</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>e.</td>
                    <td>Robo grand prix</td>
                    <td>IX-XI</td>
                    <td>2</td>
                    <td>ASN</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>f.</td>
                    <td>Robo warriors</td>
                    <td>IX-XI</td>
                    <td>2</td>
                    <td>ASN</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>g.</td>
                    <td>Sanskrit naad</td>
                    <td>VI-VIII</td>
                    <td>1</td>
                    <td>PNM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>h.</td>
                    <td>Goal rush</td>
                    <td>VI-VIII</td>
                    <td>2</td>
                    <td>MPP</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>i.</td>
                    <td>Vission in frames</td>
                    <td>VI-VIII</td>
                    <td>2-3</td>
                    <td>SHD</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>j.</td>
                    <td>Road Shield</td>
                    <td>VIII-IX</td>
                    <td>1</td>
                    <td>MVJ</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>k.</td>
                    <td>Paryavaran adalat</td>
                    <td>IX-XII</td>
                    <td>6-8</td>
                    <td>PNM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>l.</td>
                    <td>Bollywood biz bytes</td>
                    <td>XI-XII</td>
                    <td>2</td>
                    <td>RSA</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>m.</td>
                    <td>Newsroom nexus</td>
                    <td>XI-XII</td>
                    <td>3</td>
                    <td>MPP</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>n.</td>
                    <td>Matthbiz innovators</td>
                    <td>XI-XII</td>
                    <td>1</td>
                    <td>VNS</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>o.</td>
                    <td>Sci-genesis</td>
                    <td>VI-VIII</td>
                    <td>2</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>



                  <tr>
                    {" "}
                    <td rowspan="6"> 3 </td>{" "}
                    <td rowspan="6">Art Poetica 2026</td>{" "}
                    <td rowspan="6">DPS, RK Puram </td>{" "}
                    <td rowspan="6"> 16/05/2026</td>{" "}
                    <td rowspan="6">18/04/2026 </td>
                    <td>a</td>
                    <td>Blend Art</td>
                    <td>IX-XII</td>
                    <td>1</td>
                    <td rowSpan={6}>TSC</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>b.</td>
                    <td>Artistic Poesy</td>
                    <td>IX-XII</td>
                    <td>1</td>
                    <td></td>
                  </tr>

                  <tr>
                    <td>c.</td>
                    <td>Cyrical Canvas</td>
                    <td>IX-XII</td>
                    <td>1</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>d.</td>
                    <td>Inverse Rhvapsody</td>
                    <td>VI-VIII</td>
                    <td>2</td> <td></td>
                  </tr>
                  <tr>
                    <td>e.</td>
                    <td>Stage-a-verse</td>
                    <td>IX-XII</td>
                    <td>2</td> <td></td>
                  </tr>
                  <tr>
                    <td>f.</td>
                    <td>Poetic Silhouette</td>
                    <td>VI-VIII</td>
                    <td>1</td> <td></td>
                  </tr>
                  <tr>
                    {" "}
                    <td rowspan="4"> 4 </td>{" "}
                    <td rowspan="4">Rendezvous 2026</td>{" "}
                    <td rowspan="4">Air Force Bal Bharti School, Lodhi Road </td>{" "}
                    <td rowspan="4">22-Apr-26 - 23-Apr-26</td>{" "}
                    <td rowspan="4">18/04/2026 </td>
                    <td>a</td>
                    <td>Global newsroom</td>
                    <td>IX-XII</td>
                    <td>5</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>b.</td>
                    <td>Pitch Arena</td>
                    <td>XI-XII</td>
                    <td>3-5</td>
                    <td>RSA</td>  <td></td>
                  </tr>
                  <tr>
                    <td>c.</td>
                    <td>The quest</td>
                    <td>IX-XII</td>
                    <td>2</td>
                    <td>PYM</td>  <td></td>
                  </tr>
                  <tr>
                    <td>d.</td>
                    <td>Best out of Waste</td>
                    <td>VI-IX</td>
                    <td>2</td>
                    <td>PYR</td>  <td></td>
                  </tr>


                  <tr>
                    {" "}
                    <td rowspan="8"> 5 </td>{" "}
                    <td rowspan="8">Ubharte hastakshar 2026</td>{" "}
                    <td rowspan="8">SBDAV, Vasant Vihar </td>{" "}
                    <td rowspan="8">27-Apr-26 <br />(online entries submission)</td>{" "}
                    <td rowspan="8">20/04/2026</td>
                    <td>a</td>
                    <td>Art for Peace</td>
                    <td>IX-XII</td>
                    <td>1</td>
                    <td>MVJ</td>
                    <td></td>
                  </tr>


                  <tr>
                    <td>b.</td>
                    <td>Voices unbound</td>
                    <td>VI-VIII</td>
                    <td>1</td>
                    <td>TSC</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>c.</td>
                    <td>Voices of harmony</td>
                    <td>VI-VIII</td>
                    <td>1</td>
                    <td>RKS</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>d.</td>
                    <td>Rhythm for peace</td>
                    <td>IX-X</td>
                    <td>2</td>
                    <td>SKM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>e.</td>
                    <td>Peace in practice</td>
                    <td>VI-VIII</td>
                    <td>1</td>
                    <td>MPP</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>f.</td>
                    <td>Mind matters-Peace within</td>
                    <td>IX-XII</td>
                    <td>1</td>
                    <td>BSH</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>g.</td>
                    <td>Innovate for Peace</td>
                    <td>IX-XII</td>
                    <td>2</td>
                    <td>BSH</td>
                    <td></td>
                  </tr>


                </tbody>
              </table>
            </div>
          </div>
          {/* 
          <div className="row">
            <div className="table-responsive maintable">
              <table className="table">
                <thead>
                  <tr>
                    <th> Sl No </th> <th> Competition </th>{" "}
                    <th> School / Venue </th> <th> Date </th>{" "}
                    <th> Last Date of Registration </th> <th> Event </th>{" "}
                    <th> Classes </th> <th> No. of Participants </th>{" "}
                    <th> Teacher Incharge </th> <th> Remarks </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {" "}
                    <td rowspan="3"> 1 </td>{" "}
                    <td rowspan="3"> Goenka Grandeur 2025 </td>{" "}
                    <td rowspan="3"> GD Goenka School, Vasant Kunj </td>{" "}
                    <td rowspan="3"> 29 Apr-02 May 25 </td>{" "}
                    <td rowspan="3"> 18 April 2025 </td>
                    <td> (a) English Elocution </td>
                    <td> XI-XII </td>
                    <td> 2 </td>
                    <td> TSC </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (b) Folk Fusion </td>
                    <td> IX-XII </td>
                    <td> 2 </td>
                    <td> MVJ </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (c) Poetry in a frame </td>
                    <td> IX-XII </td>
                    <td> 2 </td>
                    <td> MVJ </td>
                    <td></td>
                  </tr>
                  <tr>
                    {" "}
                    <td rowspan="11"> 2 </td>{" "}
                    <td rowspan="11"> Festival Della Scienza 4.0 </td>{" "}
                    <td rowspan="11"> DPS RK Puram </td>{" "}
                    <td rowspan="11"> 26 April 2025 </td>{" "}
                    <td rowspan="11"> 18th April 2025 </td>
                    <td> (a) Mappa Mentale </td>
                    <td> VI-VIII </td>
                    <td> 2 </td>
                    <td> PYM </td> <td></td>
                  </tr>
                  <tr>
                    <td> (b) Fotografia Scientifia </td>
                    <td> IX-X </td>
                    <td> 2 </td>
                    <td> ASN </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (c) Messagio bobine </td>
                    <td> XI-XII </td>
                    <td> 2 </td>
                    <td> SHB </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (d) Science Quiz </td>
                    <td> VI </td>
                    <td> 2 </td>
                    <td> PYM </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (e) Science games </td>
                    <td> VII </td>
                    <td> 2 </td>
                    <td> PYM </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (f) Role Play </td>
                    <td> VIII </td>
                    <td> 1-2 </td>
                    <td> ASN </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (g) Demonstrate the concept </td>
                    <td> IX </td>
                    <td> 2 </td>
                    <td> SHB </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (h) Discover Science </td>
                    <td> X </td>
                    <td> 2 </td>
                    <td> SHB </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (i) Creative Solution </td>
                    <td> XI-XII </td>
                    <td> 2 </td>
                    <td> ASN </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (j) Chemistry Demo </td>
                    <td> XI-XII </td>
                    <td> 2 </td>
                    <td> SHB </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (k) Innovative Biology </td>
                    <td> XI-XII </td>
                    <td> 2 </td>
                    <td> PYM </td>
                    <td></td>
                  </tr>
                  <tr>
                    {" "}
                    <td rowspan="17"> 3 </td>{" "}
                    <td rowspan="17"> Abhivyakti 2025 </td>{" "}
                    <td rowspan="17"> Gyan Mandir public School, Naraina</td>{" "}
                    <td rowspan="17"> 7-9 May 25 </td>{" "}
                    <td rowspan="17"> 17th April 2025 </td>
                    <td> (a) Culinary Alchemy </td> <td> VI-VIII </td>{" "}
                    <td> 2 </td> <td> SHB </td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (b) Pyphysix Challenge </td> <td> IX-X </td>{" "}
                    <td> 2 </td> <td> ASN </td> <td></td>
                  </tr>
                  <tr>
                    <td> (c) Scibiz Innovators </td> <td> XI-XII </td>{" "}
                    <td> 1 </td> <td> PYM & RSA </td> <td></td>
                  </tr>
                  <tr>
                    <td> (d) Canva Strokes </td> <td> VI-VIII </td> <td> 2 </td>{" "}
                    <td> MVJ </td> <td></td>
                  </tr>
                  <tr>
                    <td> (e) Director's Cut </td> <td> XI-XII </td> <td> 2 </td>{" "}
                    <td> NEG </td> <td></td>
                  </tr>
                  <tr>
                    <td> (f) Mobilityx </td> <td> VI-VIII </td> <td> 2 </td>{" "}
                    <td> ASN </td> <td></td>
                  </tr>
                  <tr>
                    <td> (g) Roborace </td> <td> VI-VIII </td> <td> 2-3 </td>{" "}
                    <td> ASN </td> <td></td>
                  </tr>
                  <tr>
                    <td> (h) Healtech Challenge </td> <td> IX-XII </td>{" "}
                    <td> 2 </td> <td> PYM & NEG </td> <td></td>
                  </tr>
                  <tr>
                    <td> (i) Dot-a-pot </td> <td> VI-VII </td> <td> 2 </td>{" "}
                    <td> MVJ </td> <td></td>
                  </tr>
                  <tr>
                    <td> (j) Echoes of grandeur </td> <td> IX-X </td>{" "}
                    <td> 2 </td> <td> SHD </td> <td></td>
                  </tr>
                  <tr>
                    <td> (k) Warli glow </td> <td> IX-X </td> <td> 1 </td>{" "}
                    <td> MVJ </td> <td></td>
                  </tr>
                  <tr>
                    <td> (l) Candid Chats </td> <td> XI-XII </td> <td> 2 </td>{" "}
                    <td> TSC </td> <td></td>
                  </tr>
                  <tr>
                    <td> (m) Resin Art </td> <td> XI-XII </td> <td> 2 </td>{" "}
                    <td> MVJ </td> <td></td>
                  </tr>
                  <tr>
                    <td> (n) Voice of Cricket </td> <td> XI-XII </td>{" "}
                    <td> 2 </td> <td> MPP </td> <td></td>
                  </tr>
                  <tr>
                    <td> (o) Maths-o-groove </td> <td> IX-X </td> <td> 2 </td>{" "}
                    <td> VNS </td> <td></td>
                  </tr>
                  <tr>
                    <td> (p) Mathsymphonia </td> <td> XI-XII </td> <td> 1 </td>{" "}
                    <td> VNS </td> <td></td>
                  </tr>
                  <tr>
                    <td> (q) Baskethon </td> <td> VI-VIII </td> <td> 2 </td>{" "}
                    <td> MPP </td> <td></td>
                  </tr>
                  <tr>
                    {" "}
                    <td> 4 </td> <td> Transcendence 3.0 2025 </td>{" "}
                    <td>Air Force Bal Bharti School, Lodi Road </td>{" "}
                    <td>8-9 May 25 </td> <td> 29th April 2025</td>{" "}
                    <td> MUN </td> <td> VIII-XII </td> <td> 7 </td>{" "}
                    <td> SBR </td>{" "}
                    <td>
                      {" "}
                      <p> </p>{" "}
                    </td>{" "}
                  </tr>
                  <tr>
                    {" "}
                    <td rowspan="10">5 </td>{" "}
                    <td rowspan="10"> Ubharte Hastakshar 2025 </td>{" "}
                    <td rowspan="10">SBDAV Public School, Vasant Vihar </td>{" "}
                    <td rowspan="10"> 09 May 25 </td>{" "}
                    <td rowspan="10"> 30th April 2025 </td>
                    <td> (a) Litvibe </td> <td> IX-X </td> <td> 4 </td>{" "}
                    <td> TSC </td>
                    <td></td>
                  </tr>
                  <tr>
                    {" "}
                    <td> (b) Ted Talk </td> <td> XI-XII </td> <td> 1 </td>{" "}
                    <td> TSC </td> <td></td>
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (c) Rasrang </td> <td> IX-XII </td> <td> 1 </td>{" "}
                    <td> PNM </td>
                    <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (d) Vachnam </td> <td> VI-VIII </td> <td> 1 </td>{" "}
                    <td> PNM </td> <td></td>
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (e) Art Vessel </td> <td> IX-XII </td> <td> 2 </td>{" "}
                    <td> MVJ </td>
                    <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (f) Quill Quest </td> <td> VI-VIII </td> <td> 2 </td>{" "}
                    <td> MVJ </td> <td></td>
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (g) Ekal Abhivyakti </td> <td> VI-VIII </td>{" "}
                    <td> 1 </td> <td> PNM </td>
                    <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (h) Smart bites </td> <td> IX-XII </td> <td> 2 </td>{" "}
                    <td> NBH </td>
                    <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (i) Wholesome eats </td> <td> IX-X </td> <td> 1 </td>{" "}
                    <td> NBH </td> <td></td>
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (j) Cyber techie </td> <td> IX-XII </td> <td> 2 </td>{" "}
                    <td> NEG </td> <td></td>
                  </tr>
                  <tr>
                    {" "}
                    <td rowspan="4">6 </td>{" "}
                    <td rowspan="4">Confluence 2025 </td>{" "}
                    <td rowspan="4">
                      Air Force Golden Jubilee Institute, Subroto Park{" "}
                    </td>{" "}
                    <td rowspan="4"> 25 July 2025 </td>{" "}
                    <td rowspan="4"> 18 July 2025 </td>{" "}
                    <td> (a) Nukkad Natak </td> <td> IX-XII </td> <td> 5-6</td>{" "}
                    <td> SHD </td> <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (b) Poster Making </td> <td> XI-XII </td> <td> 1 </td>{" "}
                    <td> MVJ </td> <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (c) Biz Thrive </td> <td> XI-XII </td> <td> 3-4 </td>{" "}
                    <td> RSA </td> <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td>(d) Behind the brand </td> <td> X-XII </td> <td> 4 </td>{" "}
                    <td> RSA </td> <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td rowspan="4">7 </td> <td rowspan="4">Zenith 2025 </td>{" "}
                    <td rowspan="4">
                      Air Force Golden Jubilee Institute, Subroto Park{" "}
                    </td>{" "}
                    <td rowspan="4"> 25 July 2025 </td>{" "}
                    <td rowspan="4"> 18 July 2025 </td>{" "}
                    <td> (a) Veni Vidi Vici </td> <td> IX-XII</td> <td> 5+1</td>{" "}
                    <td> NEG </td> <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (b) Visions of rome </td> <td> IX-XII</td> <td> 2 </td>{" "}
                    <td> NEG </td> <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td> (c) Imago Comica </td> <td> VI-VIII </td> <td> 2 </td>{" "}
                    <td> NEG </td> <td></td>{" "}
                  </tr>{" "}
                  <tr>
                    {" "}
                    <td>(d) Iegions of laughs </td> <td>X-XII</td> <td> 1 </td>{" "}
                    <td> NEG </td> <td></td>{" "}
                  </tr>
                  <tr>
                    <td rowspan="22">8 </td>
                    <td rowspan="22">TAPSFEST 2025</td>
                    <td rowspan="22">Army Public School, Dhaula Kuan </td>
                    <td rowspan="22"> 19-20 Aug 25 </td>
                    <td rowspan="22"> 17 Aug 25 </td>
                    <td> (a) Roborace</td>
                    <td> VI-VIII</td>
                    <td> 2</td>
                    <td> ASN </td>
                    <td></td>{" "}
                  </tr>
                  <tr>
                    <td>(b) Voice through time</td>
                    <td>IX-XII</td>
                    <td>1</td>
                    <td>SHD</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (c)Science Symposium</td>
                    <td>IX-XII</td>
                    <td>2</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (d) Drama in the dimension of time</td>
                    <td>IX-XII</td>
                    <td>5</td>
                    <td>TSC</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (e)Hemlines to headlines</td>
                    <td>IX-XII</td>
                    <td>3</td>
                    <td>SHD</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (f) The Chronos</td>
                    <td>XI-XII</td>
                    <td>2</td>
                    <td>RSA</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (g) Filmic fusion</td>
                    <td>IX-XII</td>
                    <td>2</td>
                    <td>NEG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (h) Nukkad Natak</td>
                    <td>IX-XII</td>
                    <td>8–10</td>
                    <td>PNM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (i) Time-travelling</td>
                    <td>IX-XII</td>
                    <td>1</td>
                    <td>TSC</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (j) Code Craft</td>
                    <td>XI-XII</td>
                    <td>1</td>
                    <td>NEG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (k) Bake to the future</td>
                    <td>X-XII</td>
                    <td>2</td>
                    <td>NBH</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (l) Abstraction to lippan</td>
                    <td>VI-VIII</td>
                    <td>2</td>
                    <td>MVJ</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (m) Insight-X</td>
                    <td>VI-VIII</td>
                    <td>1</td>
                    <td>NEG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (n) Reimagine the classics</td>
                    <td>IX-X</td>
                    <td>2</td>
                    <td>MVJ</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (o) Jam-a-logue</td>
                    <td>IX-XII</td>
                    <td>1</td>
                    <td>TSC</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(p) Mathmorphosis</td>
                    <td>IX-XII</td>
                    <td>2</td>
                    <td>NER</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(q) Temporal titans</td>
                    <td>IX-XII</td>
                    <td>2–3</td>
                    <td>RSA</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(r) Totem pole</td>
                    <td>XI-XII</td>
                    <td>2</td>
                    <td>TMG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (s) Cryptic Hunt</td>
                    <td>X-XII</td>
                    <td>1</td>
                    <td>NEG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(t) Culinary time capsule</td>
                    <td>X-XII</td>
                    <td>1</td>
                    <td>NBH</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (u) Chiming Creations (CWSN event)</td>
                    <td>VIII-XII</td>
                    <td>2</td>
                    <td>SMA</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td> (v) Pixel epoch (CWSN event)</td>
                    <td>IX-XII</td>
                    <td>1</td>
                    <td>SMA</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowspan="6">9</td>
                    <td rowspan="6">Ramjas Inter School Debate 2025</td>
                    <td rowspan="6">Ramjas School, Pusa Road </td>
                    <td rowspan="6">
                      29 & 30 Oct (Eng) <br /> 31 Oct & 01 Nov (hindi)
                    </td>
                    <td rowspan="6"> 25 Sep 25 </td>
                    <td>Eng Debate</td>
                    <td>IX-XII</td>
                    <td>2</td>
                    <td>TSC</td>
                    <td></td>{" "}
                  </tr>
                  <tr>
                    <td>Hindi Debate</td>
                    <td>IX-XII</td>
                    <td>2</td>
                    <td>PNM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Aeon events</td>
                    <td>IX-XII</td>
                    <td>1-4</td>
                    <td>SHD</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Axiom events</td>
                    <td>VI-XII</td>
                    <td>2-6</td>
                    <td>NER</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Core events</td>
                    <td>IX-XII</td>
                    <td>1-6</td>
                    <td>NEG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Ecophoria events</td>
                    <td>IX-XII</td>
                    <td>2-3</td>
                    <td>SBR</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowspan="8">10</td>
                    <td rowspan="8">Spectrum 2025</td>
                    <td rowspan="8">DPS, Dwarka </td>
                    <td rowspan="8">11 Oct 25</td>
                    <td rowspan="8"> 3 Oct 25 </td>
                    <td>ETC events</td>
                    <td>IX–XII</td>
                    <td>2–4</td>
                    <td>TSC</td>
                    <td></td>{" "}
                  </tr>
                  <tr>
                    <td>Flux events</td>
                    <td>VI–XII</td>
                    <td>3</td>
                    <td>ASN</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Genesis</td>
                    <td>VI–XII</td>
                    <td>2–3</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Ionista</td>
                    <td>VIII–XII</td>
                    <td>2–5</td>
                    <td>MNG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Iuminarivm</td>
                    <td>VI–XII</td>
                    <td>1–5</td>
                    <td>TSC</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Mosaic</td>
                    <td>VI–XII</td>
                    <td>1–2</td>
                    <td>MVJ</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Psynapse</td>
                    <td>XI–XII</td>
                    <td>1–3</td>
                    <td>ACD</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Kirdaar</td>
                    <td>VI–XII</td>
                    <td>3–4</td>
                    <td>PNM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>Technoranza 2025</td>
                    <td>Bal Bharti Public School, Ganga Ram Hospital Marg</td>
                    <td>17-Oct-25</td>
                    <td>5-Oct-25</td>
                    <td>Technovanza events</td>
                    <td>VI-XII</td>
                    <td>1-2</td>
                    <td>NEG</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowspan="5">12</td>
                    <td rowspan="5">Anubhav 2025</td>
                    <td rowspan="5">Air Force School ASTE Bangalore </td>
                    <td rowspan="5">22 Nov 25</td>
                    <td rowspan="5"> 28 Oct 25 </td>
                    <td>Swar Lahori (Online)</td>
                    <td>VI-IX</td>
                    <td>1</td>
                    <td>RKS</td>
                    <td></td>{" "}
                  </tr>
                  <tr>
                    <td>Sholka Suman (Online)</td>
                    <td>VI-IX</td>
                    <td>1</td>
                    <td>PNM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Tales on Strings (Online)</td>
                    <td>VI-VIII</td>
                    <td>1</td>
                    <td>TSC</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Young tycoons (Online)</td>
                    <td>IX-XI</td>
                    <td>2</td>
                    <td>RSA</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Word Whirl (Online)</td>
                    <td>IX-XI</td>
                    <td>1</td>
                    <td>TSC</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowSpan="2">13</td>
                    <td rowSpan="2">Y Kumar Memorial Contest 2026</td>
                    <td rowSpan="2">Springdales School, Pusa Road</td>
                    <td rowSpan="2">22 Jan 2026 and 2 Feb 2026 </td>
                    <td rowSpan="2">18 Jan 2026 </td>
                    <td>Quiz & Essay Writing</td>
                    <td>XI-XII</td>
                    <td>2</td>
                    <td>DAT</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>Painting</td>
                    <td>VI-VIII</td>
                    <td>2</td>
                    <td>MVJ</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td rowSpan="5">14</td>
                    <td rowSpan="5">
                      Annual Inter-School Garden Festival 2026
                    </td>
                    <td rowSpan="5">Cambridge School, Srinivaspuri</td>
                    <td rowSpan="5">30 Jan 2026 </td>
                    <td rowSpan="5">20 Jan 2026 </td>
                    <td>(a) Plantelligence</td>
                    <td>VII-VIII</td>
                    <td>2</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(b) Nature's nest</td>
                    <td>VI-VIII</td>
                    <td>2</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(c) Terrabloom</td>
                    <td>VI-VIII</td>
                    <td>2</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(d) Pebble Palette</td>
                    <td>VIII-IX</td>
                    <td>2</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>(e) CultiCraft</td>
                    <td>VI-X</td>
                    <td>2</td>
                    <td>PYM</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div> 
          */}
        </div>
      </div >
    </>
  );
};

export default InterSchoolCorner;
